import React from "react";
import Header from "components/Headers/Header";
import { Col, Container, Row, Button } from "reactstrap";
import { IoMdArrowBack } from "react-icons/io";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import { FaYoutube } from "react-icons/fa6";

function SingleChat() {
  return (
    <>
      <div className="trending">
        <button type="button" className="text-white btn btn-primary mx-4 my-3" onClick={() => window.history.back()}>
          <IoMdArrowBack /> Go Back
        </button>{" "}
        <Container className="single-chat-container">
          <div className="single-chat">
            <a
              className="text-white btn btn-primary "
              href="https://youtu.be/C5oVmQTSg_w"
              target="_blank"
            >
              <FaYoutube className="youtube-icon" /> Play Video
            </a>
            <a
              className="text-white btn btn-primary mt-2 "
              href="https://athlete-for-brand.web.app/login?redirect=/chat"
              target="_blank"
            >
              Go to site
            </a>
          </div>
        </Container>
      </div>
    </>
  );
}

export default SingleChat;

{
  /* <a href="https://youtu.be/C50VmQTSg_W" target="_blank">
              https://youtu.be/C50VmQTSg_W{" "}
            </a> */
}
